import React from "react"
export const LoadingView = () => {
  return (
    <div className="z-2 absolute flex h-full w-full items-center justify-center bg-white opacity-50">
      <div className="pi pi-spinner animate-spin text-[30px]" />
    </div>
  )
}
